import React, { ReactNode } from "react";
import { styled, useTheme } from "@mui/material/styles";
import pxToRem from "libs/pxToRem";
import Alert from "@mui/material/Alert";
import Link from "@mui/material/Link";
/*
    orange: {backgroundColor: "#ffeece",color: "#f17f00"},zeplin> color: #f77200
    yellow: { text: "#ee9d00", background: "#fff7cc" },
    green: { text: "#069661", background: "#d2f6e2" },
    red: { text: "#dd1111", background: "#ffe0e0" },
    blue: { text: "#009bba", background: "#c7f2fa" }
*/

const buildAlert = (background: string, foreground: string) =>
  styled(Alert)({
    width: "100%",
    borderRadius: 8,
    backgroundColor: background,
    "& .MuiAlert-message": {
      fontSize: pxToRem(16),
      fontWeight: "bold !important",
      color: foreground,
    },
    "& .MuiAlert-icon": {
      color: `${foreground} !important`,
      fontSize: 25,
    },
  });

const OrangeAlert = buildAlert("#ffeece", "#f77200");
const GreenAlert = buildAlert("#d2f6e2", "#069661");
const BlueAlert = buildAlert("#c7f2fa", "#009bba");
const YellowAlert = buildAlert("#fff7cc", "#ee9d00");
const RedAlert = buildAlert("#ffe0e0", "#dd1111");

export enum EAlertType {
  warning = 0,
  info,
  success,
  error,
  other,
}

interface IAlertSectionProps {
  alertType: EAlertType;
  variant?: any;
  icon?: ReactNode;
  title?: string;
  inlineLink?: string;
  rightLink?: string;
  onClick?: () => void;
  onClose?: () => void;
  marginBottom?: number;
  children?: React.ReactNode;
}

const AlertSection: React.FC<IAlertSectionProps> = ({
  alertType,
  variant,
  icon,
  inlineLink,
  rightLink,
  onClick,
  onClose,
  children,
  marginBottom,
}) => {
  const theme = useTheme();
  switch (alertType) {
    case EAlertType.warning:
      return (
        <OrangeAlert
          variant={variant}
          severity="warning"
          icon={icon}
          onClick={onClick}
          onClose={onClose}
          action={<u>{rightLink}</u>}
          style={marginBottom ? { marginBottom } : undefined}
        >
          {children}
          <Link
            component="button"
            onClick={onClick}
            style={{
              fontFamily: theme.typography.fontFamily,
              verticalAlign: "top",
              marginLeft: pxToRem(4),
              fontSize: pxToRem(16),
              fontWeight: "bold",
              color: "#f77200",
              textDecoration: "underline",
            }}
          >
            {inlineLink}
          </Link>
        </OrangeAlert>
      );
    case EAlertType.success:
      return (
        <GreenAlert
          variant={variant}
          severity="success"
          icon={icon}
          onClick={onClick}
          onClose={onClose}
          action={<u>{rightLink}</u>}
          style={marginBottom ? { marginBottom } : undefined}
        >
          {children}
          <Link
            component="button"
            onClick={onClick}
            style={{
              fontFamily: theme.typography.fontFamily,
              verticalAlign: "top",
              marginLeft: pxToRem(4),
              fontSize: pxToRem(16),
              fontWeight: "bold",
              color: "#069661",
              textDecoration: "underline",
            }}
          >
            {inlineLink}
          </Link>
        </GreenAlert>
      );
    case EAlertType.info:
      return (
        <BlueAlert
          variant={variant}
          severity="info"
          icon={icon}
          onClick={onClick}
          onClose={onClose}
          action={<u>{rightLink}</u>}
          style={marginBottom ? { marginBottom } : undefined}
        >
          {children}
          <Link
            component="button"
            onClick={onClick}
            style={{
              fontFamily: theme.typography.fontFamily,
              verticalAlign: "top",
              marginLeft: pxToRem(4),
              fontSize: pxToRem(16),
              fontWeight: "bold",
              color: "#009bba",
              textDecoration: "underline",
            }}
          >
            {inlineLink}
          </Link>
        </BlueAlert>
      );
    case EAlertType.error:
      return (
        <RedAlert
          variant={variant}
          severity="warning"
          icon={icon}
          onClick={onClick}
          onClose={onClose}
          action={<u>{rightLink}</u>}
          style={marginBottom ? { marginBottom } : undefined}
        >
          {children}
          <Link
            component="button"
            onClick={onClick}
            style={{
              fontFamily: theme.typography.fontFamily,
              verticalAlign: "top",
              marginLeft: pxToRem(4),
              fontSize: pxToRem(16),
              fontWeight: "bold",
              color: "#dd1111",
              textDecoration: "underline",
            }}
          >
            {inlineLink}
          </Link>
        </RedAlert>
      );
    default:
      return (
        <YellowAlert
          variant={variant}
          severity="error"
          icon={icon}
          onClick={onClick}
          onClose={onClose}
          action={<u>{rightLink}</u>}
          style={marginBottom ? { marginBottom } : undefined}
        >
          {children}
          <Link
            component="button"
            onClick={onClick}
            style={{
              fontFamily: theme.typography.fontFamily,
              verticalAlign: "top",
              marginLeft: pxToRem(4),
              fontSize: pxToRem(16),
              fontWeight: "bold",
              color: "#ee9d00",
              textDecoration: "underline",
            }}
          >
            {inlineLink}
          </Link>
        </YellowAlert>
      );
  }
};

export default AlertSection;
